import React from 'react'
import UserRow from './UserRow.js'
import getLabel from '../../utilities/label.js'

export default function UserList(props) {
  const { users } = props
  let rows = []
  let lastChar, currentChar
  users.forEach( (user) => {
    // let hiddenUser = user.hide_on_lists ? 'hide' : ''
    currentChar = user.sort_name.substr(0,1)
    // if (currentChar !== lastChar && hiddenUser !== 'hide') {
    if (currentChar !== lastChar) {
      rows.push(
        <div
          className='user-row'
          key={ currentChar }>
          <p className='subheader'>{ currentChar }</p>
        </div>
      )
      lastChar = currentChar
    }
    rows.push(
      // <div key={ user.id } className={ hiddenUser } >
      <div key={ user.id }>
        <UserRow
          user={ user }
          dimUsers={true}
          activeTab='attendees'
        />
        <hr/>
      </div>
    )
  })
  return rows.length ?
    (
      <div className='attendees'>
        { rows }
      </div>
    ) : (
      <div className="no-results-message">
        { getLabel('no_results_found') }
      </div>
    )
}
